import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";
var SvgMenu = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, props = __rest(_a, ["size"]);
    return (React.createElement(Svg, __assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        React.createElement("path", { fill: "currentColor", d: "M22.92 5.969H1.08C.462 5.969 0 5.5 0 4.984 0 4.47.514 4 1.08 4h21.84c.617 0 1.08.469 1.08.984 0 .516-.514.985-1.08.985zM22.92 12.922H1.08c-.617 0-1.08-.469-1.08-.985 0-.515.514-.984 1.08-.984h21.84c.617 0 1.08.469 1.08.985 0 .515-.514.984-1.08.984zM22.92 19.875H1.08c-.617 0-1.08-.47-1.08-.985s.514-.984 1.08-.984h21.84c.617 0 1.08.469 1.08.984 0 .516-.514.985-1.08.985z" })));
};
export default SvgMenu;
//# sourceMappingURL=Menu.js.map